const getters = {
  buttonAuth: state => state.auth.buttonAuth,
  routerAuth: state => state.auth.routerAuth,
  menuAuth: state => state.auth.menuAuth,
  dataAuth: state => state.auth.dataAuth,
}

export default getters
